// Виджет не нуждается в styler
/* eslint-disable styler/check-styler */
import { createWidget } from '@alfa-bank/site-util-create-widget';

import type { TDesktopProps, ISwitcherDesktopDeps } from '../models';
import { Switcher as Component } from '../switcher';

import styles from './styles/styles.css';

/** @widgetName SmeInternetAcquiring.SwitcherDesktop */
export const SwitcherDesktop = createWidget<ISwitcherDesktopDeps, TDesktopProps>({
    styles,
})(Component);
